import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import TimelineRenderer from "@/components/timeline/TimelineRenderer";
import { SlashMark } from "@/components/Logo";
import { api } from "@/lib/api";
import { themeOf } from "@/lib/themes";

export default function Embed() {
  const { username, slug } = useParams();
  const [params] = useSearchParams();
  const [tl, setTl] = useState(null);
  const [err, setErr] = useState(false);
  const ref = useRef(null);

  const themeOverride = params.get("theme");
  const showBranding = params.get("branding") !== "0";
  const showHeader = params.get("header") !== "0";

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/public/${username}/${slug}`); setTl(data); }
      catch { setErr(true); }
    })();
  }, [username, slug]);

  // auto-resize: post height to parent
  useEffect(() => {
    if (!tl) return;
    const send = () => window.parent?.postMessage({ type: "timeline-embed-height", height: document.body.scrollHeight }, "*");
    send();
    const ro = new ResizeObserver(send);
    ro.observe(document.body);
    return () => ro.disconnect();
  }, [tl]);

  if (err) return <div className="min-h-screen grid place-items-center text-muted-foreground">Timeline unavailable.</div>;
  if (!tl) return <div className="min-h-screen grid place-items-center bg-background"><div className="animate-pulse"><SlashMark size={32} color="hsl(var(--primary))" /></div></div>;

  const view = themeOverride && themeOf(themeOverride) ? { ...tl, theme: themeOverride } : tl;
  const t = themeOf(view.theme);

  return (
    <div ref={ref} className="min-h-screen relative" style={{ background: t.bg }}>
      <TimelineRenderer timeline={view} hideHeader={!showHeader} />
      {showBranding && (
        <a href={`${window.location.origin}/t/${username}/${slug}`} target="_blank" rel="noreferrer"
          className="fixed bottom-3 right-3 z-50 glass h-8 px-3 rounded-full text-[11px] font-medium flex items-center gap-1.5" style={{ color: t.text }}>
          <SlashMark size={11} color={t.accent} /> Made with Timeline
        </a>
      )}
    </div>
  );
}
